import React, { Fragment, useState } from "react";
import PropTypes from 'prop-types';
import { SvgIcon } from '@mui/material';
import { InfoOutlined as InfoIcon } from '@mui/icons-material';
import ProductModal from "./ProductModal";
import "./ProductModalList.scss"

export default function ProductModalList({ data, carriers, category, handleSubmitClick}) {

  const [productModalShow, setProductModalShow] = useState(false);
  const [modalContentIndex, setModalContentIndex] = useState(null);

  const handleProductModalClose = (scroll) => {
    handleModalContent(null);
    setProductModalShow(false);
    if (scroll) {
      handleSubmitClick();
    }
  };

  const handleProductModalShow = (index) => {
    handleModalContent(index);
    setProductModalShow(true);
  };

  const handleModalContent = (index) => {
    setModalContentIndex(index);
  };

  return (
      <div className="modal-list-container">
        <Fragment>
          {data.map((p, index) => {
            return <button className={`button-pill light-background`} key={index} onClick={() => handleProductModalShow(index)}>
                        <SvgIcon component={p.icon} color="primary"/>
                        <span className={`title primary-color`}>{p.buttonTitle}</span>
                        <InfoIcon color="primary"/>
                      </button>
            }
          )}
          {productModalShow && 
          <ProductModal
            productModalShow={productModalShow}
            handleProductModalClose={handleProductModalClose}
            productData={data[modalContentIndex].modalContent}
            carriers={carriers}
            category={category}
          />
          }
        </Fragment>
      </div>
  )
}

ProductModalList.propTypes = {
  data: PropTypes.array,
}
